import { AuthContext, type AuthContextType } from '@/hooks/authContext';
import { setUser } from '@/utils/metrics';
import { useOktaAuth } from '@okta/okta-react';
import * as Sentry from '@sentry/react';
import { useContext } from 'react';

export const AuthContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();

  if (authState?.isAuthenticated && authState?.idToken?.claims.sub) {
    Sentry.setUser({
      email: authState?.idToken?.claims.email,
      id: authState?.idToken?.claims.sub,
      username: authState?.idToken?.claims.name,
    });
    setUser({
      id: authState?.idToken?.claims.sub,
    });
  }

  return <AuthContext.Provider value={{ authState, oktaAuth }}>{children}</AuthContext.Provider>;
};

// oxlint-disable-next-line react-refresh/only-export-components
export const useAuthContext = (): AuthContextType => useContext(AuthContext);
